const gameStates = {
  LOADING: "loading",
  INTRO: "intro",
  PLAYING: "playing",
  PROMPT: "prompt",
  AUDIO_LISTEN: "audio_listen",
  AUDIO_RECORD: "audio_record",
  ENDGAME: "endgame",
};

export default gameStates;
